import { ChartTypeValue } from 'src/common/components/ChartTypeToggle/ChartTypeToggle';
import { UsageTypeValue } from 'src/common/components/UsageTypeSwitch/UsageTypeSwitch';
import { DetailsTypeValue } from '../UsageChartsSection';
import { SESSION_DETAILS_QUERY_KEY } from 'src/simInventory/hooks/useSessionsDetails';

type ChartFilters = {
  id: string;
  usageType: UsageTypeValue;
  detailsType: DetailsTypeValue;
};

type DailyChartFilters = ChartFilters & {
  chartType: ChartTypeValue;
};

export const detailsQueries = {
  details: ['Details'],
  all: () => [...detailsQueries.details, 'Usage'],
  monthlyUsage: (filters: ChartFilters) => [...detailsQueries.all(), 'monthlyUsage', filters],
  dailyUsage: (filters: DailyChartFilters) => [...detailsQueries.all(), 'dailyUsage', filters],
  sessionDetails: (imsi?: string | null) => [
    ...detailsQueries.details,
    SESSION_DETAILS_QUERY_KEY,
    imsi,
  ],
};
